import { render } from "./LotCardWaitlist.vue?vue&type=template&id=0f129c06&scoped=true&ts=true&lang=pug"
import script from "./LotCardWaitlist.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotCardWaitlist.vue?vue&type=script&lang=ts&setup=true"

import "./LotCardWaitlist.vue?vue&type=style&index=0&id=0f129c06&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f129c06"]])

export default __exports__